import axios from "axios";
import { createClient } from "../util/axios-helpers";
import { endpoint } from "../util/http-helpers";

export interface CheckoutRequest {
    serviceCode: string;
    quantity?: number;
}

export interface CheckoutResponse {
    orderId: string;
    clientSecret: string;
    amount: number;
    platformFee: number;
    partnerAmount: number;
}

export interface Order {
    id: string;
    dealId: string;
    dealTitle: string;
    amount: number;
    status: string;
    createDate: string;
    completedDate: string | null;
}

export enum OrderStatus {
    Pending = "Pending",
    Processing = "Processing",
    Completed = "Completed",
    Failed = "Failed",
    Refunded = "Refunded"
}

export const getOrderStatusLabel = (status: string): string => {
    switch (status) {
        case "Pending":
            return "Pending";
        case "Processing":
            return "Processing";
        case "Completed":
            return "Completed";
        case "Failed":
            return "Failed";
        case "Refunded":
            return "Refunded";
        default:
            return status || "Unknown";
    }
};

export const checkout = (request: CheckoutRequest) => {
    const client = createClient(axios);
    return client.post<CheckoutResponse>(endpoint('api/v1/orders/checkout'), request);
};

export const getOrderById = (orderId: string) => {
    const client = createClient(axios);
    return client.get<Order>(endpoint(`api/v1/orders/${orderId}`));
};

export const getMyOrders = () => {
    const client = createClient(axios);
    return client.get<Order[]>(endpoint('api/v1/me/orders'));
};
